import React from 'react';
import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
  Input,
  Label,
  RadioButtonGroup,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@roger/ui-components';
import { ODOR_TYPES, PRESENCE_OPTIONS } from '../../../constants/wounds';
import type { OdorState } from '../assessmentFormTypes';

interface OdorSectionProps {
  state: OdorState;
  onChange: (update: Partial<OdorState>) => void;
}

const OdorSection: React.FC<OdorSectionProps> = ({ state, onChange }) => (
  <AccordionItem value='odor' className='border rounded-md px-3'>
    <AccordionTrigger className='text-sm font-medium py-3'>
      Odor
    </AccordionTrigger>
    <AccordionContent className='pb-3 space-y-3'>
      <RadioButtonGroup
        options={PRESENCE_OPTIONS.map(o => ({
          value: o.value,
          label: o.label,
        }))}
        value={state.value}
        onValueChange={v =>
          onChange({
            value: v,
            ...(v !== 'not_assessed' && { notAssessedReason: '' }),
          })
        }
      />
      {state.value === 'not_assessed' && (
        <Input
          placeholder='Reason not assessed...'
          value={state.notAssessedReason}
          onChange={e => onChange({ notAssessedReason: e.target.value })}
          inputSize='sm'
        />
      )}
      {state.value === 'yes' && (
        <div className='space-y-1'>
          <Label className='text-xs'>Type</Label>
          <Select
            value={state.type}
            onValueChange={v =>
              onChange({ type: v, ...(v !== 'other' && { typeOther: '' }) })
            }
          >
            <SelectTrigger selectSize='sm'>
              <SelectValue placeholder='Select type...' />
            </SelectTrigger>
            <SelectContent>
              {ODOR_TYPES.map(t => (
                <SelectItem key={t.value} value={t.value}>
                  {t.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {state.type === 'other' && (
            <Input
              placeholder='Describe odor...'
              value={state.typeOther}
              onChange={e => onChange({ typeOther: e.target.value })}
              inputSize='sm'
            />
          )}
        </div>
      )}
    </AccordionContent>
  </AccordionItem>
);

export default OdorSection;
